import i18n from '../i18n';

const sortOptions = [
  { value: 'DESC', label: i18n.t('common.downward') },
  { value: 'ASC', label: i18n.t('common.upward') },
  { value: 'ORDER_FIELD', label: i18n.t('common.orderField') },
];

export { sortOptions };
